import { formatMealDateTime } from '../utils/dateFormat';

/**
 * meal.location is never written anywhere (createListing writes
 * street/city/state to a private subdoc instead) -- neighborhood is the
 * only location field public meal docs actually carry, so that's what
 * a shared card can safely render.
 */
const MealCard = ({ meal, onClick, children }) => {
  const { date, time, dayOfWeek } = formatMealDateTime(meal.dateTime);

  return (
    <div className="meal-card" onClick={onClick}>
      <div className="meal-card-image">
        {meal.photoUrl ? (
          <img src={meal.photoUrl} alt={meal.title} />
        ) : (
          <div className="meal-card-placeholder">
            <span>No Photo</span>
          </div>
        )}
      </div>
      <div className="meal-card-info">
        <h3 className="meal-card-title">{meal.title}</h3>
        <p className="meal-card-datetime">{dayOfWeek}, {date} at {time}</p>
        <p className="meal-card-location">{meal.neighborhood}</p>
        {children}
      </div>
    </div>
  );
};

export default MealCard;
